// extracted by mini-css-extract-plugin
module.exports = {"fab_container":"Fab_fab_container__1DxLL","main_fab_container":"Fab_main_fab_container__1zwKE"};